import { useEffect } from 'react';

const SITE_NAME = 'PlusPlus';

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith('link') ? 'link' : 'meta');
    const m = selector.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  const prev = el.getAttribute(attr);
  el.setAttribute(attr, value);
  return () => (prev == null ? el.removeAttribute(attr) : el.setAttribute(attr, prev));
}

/**
 * Define título, descrição, canonical, Open Graph e robots da página atual.
 * Ao sair da página, restaura o que estava antes.
 */
export default function useSeo({ title, description, path, noindex = false }) {
  useEffect(() => {
    const url = `${window.location.origin}${path ?? window.location.pathname}`;
    const undo = [];
    const prevTitle = document.title;
    if (title) document.title = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

    if (description) {
      undo.push(setMeta('meta[name="description"]', 'content', description));
      undo.push(setMeta('meta[property="og:description"]', 'content', description));
      undo.push(setMeta('meta[name="twitter:description"]', 'content', description));
    }
    if (title) {
      undo.push(setMeta('meta[property="og:title"]', 'content', document.title));
      undo.push(setMeta('meta[name="twitter:title"]', 'content', document.title));
    }
    undo.push(setMeta('link[rel="canonical"]', 'href', url));
    undo.push(setMeta('meta[property="og:url"]', 'content', url));
    undo.push(setMeta('meta[name="robots"]', 'content', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1'));

    return () => {
      document.title = prevTitle;
      undo.forEach((fn) => fn());
    };
  }, [title, description, path, noindex]);
}
